<article class="layers-container">
  @if (!drawer.opened) {
    <button aria-label="open side panel"
            [attr.data-testid]="'open side panel'"
            class="sidebar-button"
            (click)="toggleSidePanel('')">
      <mds-icon
        [key]="icons.RIGHT_PANEL_OPEN"
        [width]="24"
        [height]="24"
        class="button-icon icon-margin-right"
      ></mds-icon>
    </button>
  }

  <mat-drawer-container
    class="layers-content"
    [ngClass]="{ 'no-backdrop': drawerMode === 'over', 'cursor-progress': loadingAnalyzeData }"
  >
    <mat-drawer #drawer [mode]="drawerMode" position="end" class="sidepanel-container sidepanel custom-spacing">
      <app-side-panel
        [data]="sidepanelDetails"
        (valueChanged)="sidepanelEvent($event)"
        [analyzeData]="analyzeDataset"
        [view]="sidepanelView"
        (showSidePanel)="toggleSidePanel($event)"
        style="height: 100%"
        [info]="productInfo"
        [app]="app"
        [updatingAIStatus]="updatingAIStatus"
        (onClickValidateAINode)="validateSelectedNode()"
      ></app-side-panel>
    </mat-drawer>
    <mat-drawer-content
      #drawerContent
      class="drawer-content"

      [ngClass]="drawerMode === 'over' ? 'without-padding' : 'with-padding'"
      >
      @if (['overview', 'dpm'].includes(app?.layer)) {
        <section class="analyze-full-width">
          <app-overview
            [drawerOpened]="drawer?.opened"
            [isfrom]="app?.layer"
            [rid]="rid"
            class="analyze-full-width"
          ></app-overview>
        </section>
      } @else {
        @if (isLoading) {
          <mds-loader></mds-loader>
        }
        @if (!isLoading) {
          <app-layers-header
            style="padding-left: 1rem"
            [showAllData]="showAllData"
            [breadcrumbData]="breadcrumbData"
            [showSetDefaultView]="showSetDefaultView"
            [groupLowImpactNodes]="groupLowImpactNodes"
            [analyzeView]="analyzeView"
            [tariffForm]="tariffSchema"
            [allTariffOptions]="allTariffOptions$ | async"
            [showAllToggleFilter]="showAllToggleSwitch"
            (showAllToggle)="onShowAllToggle($event)"
            (tariffToggle)="onTariffToggle($event)"
            (selectedTariff)="onSelectTariff($event)"
            (searchTariff)="onSearchTariff($event)"
            (backToDefault)="backToDefaultView()"
            (groupNodesToggle)="onGroupSmallNodesToggle($event)"
            (onBreadcrumbSelect)="onBreadcrumbSelect($event)"
          ></app-layers-header>
          @if (analyzeView) {
            @switch (analyzeView) {
              @case ('sankey') {
                <app-sankey-wrapper></app-sankey-wrapper>
              }
              @case ('graph') {
                <app-graph-wrapper
                  [defaultView]="backToDefault"
                  [resize]="svgResize"
                ></app-graph-wrapper>
              }
              @case ('grid') {
                <app-default-grid-wrapper
                  [ngClass]="{ 'show-margin': drawer.opened }"
                  (gridEvents)="onGridEvent($event)"
                  [drawer]="drawer"
                ></app-default-grid-wrapper>
              }
              @case ('costing-grid') {
                <app-costing-grid-wrapper></app-costing-grid-wrapper>
              }
              @default {
                <app-map-wrapper (openSidebar)="onOpenSidebar($event)"></app-map-wrapper>
              }
            }
          }
        }
      }
      @if (drawer.opened) {
        @if (pins.length > 0 && layer !== 'recycled_content') {
          <div class="sidepanel-button-section">
            <mds-button
              aria-label="switch to sidepanel"
              role="button"
              tabindex="0"
              [type]="sidepanelView === 'sidepanel' ? 'primary' : 'secondary'"
              (click)="switchSidepanel('sidepanel')"
              class="button-width switch-button"
              >
              <mds-icon
                [key]="icons.FILTER_CENTER_FOCUS"
                [width]="20"
                [height]="20"
                class="button-icon"
                [pathColors]="sidepanelView === 'sidepanel' ? '' : primaryColor"
              ></mds-icon>
            </mds-button>
            <mds-button
              aria-label="switch to performance analytics"
              role="button"
              tabindex="0"
              [type]="sidepanelView === 'performance-analytics' ? 'primary' : 'secondary'"
              (click)="switchSidepanel('performance-analytics')"
              class="pad-top-4 button-width switch-button"
              >
              <mds-icon [key]="icons.PERFORMANCE_ANALYTICS" [width]="20" [height]="20" class="button-icon"></mds-icon>
            </mds-button>
          </div>
        }
      }
    </mat-drawer-content>
  </mat-drawer-container>
</article>
